import flarebase from 'flarebase'


class AlogAuth extends flarebase.auth.Auth {
  constructor() {
    super();
  }
}

let auth = new AlogAuth();

auth.on('fail', (e) => {
  spat.modal.alert(e.message);
});


export default auth;